export default {"src":"/_next/static/media/medias2.0cb2e824.svg","height":15,"width":327,"blurWidth":0,"blurHeight":0};